import { Link } from "react-router-dom";
import { Navbar } from "../components/layout/Navbar";
import { Footer } from "../components/layout/Footer";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Clock, ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const WaitingApproval = () => {
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col bg-background" dir={language === "ar" ? "rtl" : "ltr"}>
      <Navbar />
      
      <main className="flex-1 py-12">
        <div className="container mx-auto px-4 max-w-md">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            {t("common.backToHome")}
          </Link>

          <Card className="border-border shadow-lg animate-fade-in">
            <CardHeader className="text-center">
              <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                <Clock className="w-8 h-8 text-primary" />
              </div>
              <CardTitle className="text-2xl">
                {t("waiting.projectholder.title")}
              </CardTitle>
              <CardDescription>
                {t("waiting.projectholder.thanks")}
              </CardDescription>
            </CardHeader>

            <CardContent className="text-center">
              <p className="text-muted-foreground mb-6">
                {t("waiting.projectholder.message")}
              </p>
              
              <div className="bg-muted/50 rounded-lg p-4 mb-6">
                <p className="text-sm text-muted-foreground">
                  {t("waiting.projectholder.processTimeProject")}
                </p>
              </div>

              <Link to="/">
                <Button variant="outline" className="w-full">
                  {t("common.backToHome")}
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default WaitingApproval;